<template>
  <div class="layer detailLayer">
    <div class="inner">
      <div class="itemInner">
          <div class="name">{{ item.info.name[lang] }}</div>
          <div v-if="item.thumb !== '' || setDefaultImage" class="thumb">
            <div v-if="item.thumb"
              :style="{backgroundImage: `url('${item.thumb}')`}"
              :data-ratio="item.thumbRatio"
              alt=""
              class="thumbImg"></div>
            <img v-else-if="setDefaultImage" src="@/assets/img/img_product_default.png" alt="" class="defaultImg">
          </div>
      </div>
      <div class="itemInfo">
        <div class="infoLabel"
          :style="{
            ...skinStyle('productBtncart', 'color'),
            ...skinStyle('productBtncart', 'border-color')}">{{locale.detail_information}}</div>
        <div class="infoDetail">
          <div class="desc">{{ item.info.desc[lang] }}</div>
          <div class="detail">{{ item.info.detail[lang] }}</div>
        </div>
        <div class="btns">
          <button
            type="button"
            class="btn btnCancel"
            @click.stop="close">{{locale.close}}</button>
          <button
            type="button"
            class="btn btnCart"
            :style="{
              ...skinStyle('productBtncart', 'background-color'),
              ...skinStyle('productBtncart', 'border-color'),
            }"
            @click.stop="addCart">{{locale.add_cart}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import { mapGetters } from 'vuex'

export default {
  name: 'ItemDetail',
  props: [
    'lang',
    'responsive',
    'locale',
    'item',
    'setDefaultImage'
  ],
  components: {
  },
  computed: {
    ...mapGetters({
      getGuestTypePrice: 'util/getGuestTypePrice',
      getTax: 'payment/getTax',
      pointColors: 'common/getPointColors',
      getAvailableDay: 'util/getAvailableDay',
      getSetting: 'product/getProductSetting'
    }),
  },
  mounted () {
    this.$nextTick(() => {
      document.body.classList.add('layerOn')
    })
  },
  beforeDestroy () {
    document.body.classList.remove('layerOn')
  },
  data () {
    return {
    }
  },
  methods: {
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    close () {
      this.$emit('close')
    },
    addCart () {
      this.$emit('addCart', this.item)
    }
  }
}
</script>
<style lang="scss" scoped>
.layer {
  padding: 40px 30px;
  .inner {
    display: flex !important;
    flex-direction: row;
    max-width: 1200px;
    height: auto;
    min-height: 400px;
    padding: 0;
  }
  .itemInner {
    flex: 2.25;
    width: 800px;
    height: auto;
    overflow: auto;
    padding: 30px;
  }
  .defaultImg {
    max-width: none !important;
  }
  .itemInfo {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 30px;
    border-left: 1px solid $color-lgrey2;
    background-color: $bg-default;
  }
  .name {
    margin-bottom: 16px;
    font-size: 24px;
    font-weight: bold;
  }
  .infoLabel {
    margin-bottom: 16px;
    padding-bottom: 8px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 2px solid $color-dark;
  }
  .infoDetail {
    flex: 1;
    max-height: 100%;
    overflow: auto;
    font-size: 18px;
    color: $color-dgrey;
  }
  .desc {
    margin-bottom: 20px;
  }
  .btns {
    display: flex;
    margin-top: auto;
    font-size: 20px;
    .btn {
      border-radius: 10px;
      &.btnCancel {
        width: auto;
        min-width: 0;
      }
      &.btnCart {
        flex: 1;
        width: auto;
      }
    }
  }
}
@media screen and (max-width: 1023px) {
  .layer {
    padding: 40px 15px;
    .inner {
      display: block !important;
      max-width: 600px;
    }
    .itemInner {
      padding: 30px 15px;
    }
    .itemInfo {
      padding: 30px 15px;
      border-left: none;
      border-top: 1px solid $color-lgrey2;
    }
    .name {
      font-size: 20px;
    }
    .infoLabel {
      font-size: 16px;
    }
    .infoDetail {
      font-size: 16px;
    }
    .btns {
      font-size: 16px;
    }
  }
}
</style>